// @ts-check
import Vue from 'vue';
import SpecialBetCombinationsRequest from '@bto-services/api/shared/special-bet-combinations';
import SpecialBetCombinationsModel from 'bto-models/betslip/special-bet-combinations.model';


/**
 * Get default state for betslip messages
 */
const getDefaultState = () => ({
  /**
   * Map of special bet combination Id -> specail bet combination model
   * @type {{[id:string]:SpecialBetCombinationsModel}}
   */
  specialBetCombs: {},
  /**
   * Map of special bet combination Id -> stake (number as string)
   * @type {{[id:string]:string}}
   */
  stakes: {},
});

export const specialBetCombStore = Vue.observable(getDefaultState());

/**
 * Fetch special bet combinations and load them in store
 */
export function fetchSpecialBetCombinations() {
  const request = new SpecialBetCombinationsRequest();
  request.execute((resp) => {
    if (resp.data) {
      const specialBetCombinationsMap = resp.data.reduce((acc, s) => {
        acc[s.Id] = new SpecialBetCombinationsModel(s);
        return acc;
      }, {});
      Object.assign(specialBetCombStore.specialBetCombs, specialBetCombinationsMap);
    }
  });
}